module.exports = __webpack_public_path__ + "img/GLPR_PVM2.8b2ecbeb.svg";